import { render, staticRenderFns } from "./SpeakingQuiz.vue?vue&type=template&id=10dca549&scoped=true&"
import script from "./SpeakingQuiz.vue?vue&type=script&lang=js&"
export * from "./SpeakingQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dca549",
  null
  
)

export default component.exports